let en = {
    name: "English",
    tag: 'en',
    values: {

    }
}

export default en